var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 26,
    viewBox: "0 0 138 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 26,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1562_6817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4842 2.9999C8.90655 2.9999 5.76941 4.88644 3.6022 8.21543L-0.00390625 13.8502H2.43687C2.61402 16.3866 3.75155 18.76 5.6177 20.4868C7.48385 22.2137 9.93819 23.1641 12.4807 23.1443C16.0868 23.1443 19.1955 21.2578 21.3876 17.9004L24.9937 12.2408H22.5245C22.3444 9.7108 21.2047 7.34518 19.3385 5.62753C17.4723 3.90988 15.0204 2.96995 12.4842 2.9999V2.9999ZM12.4842 19.3713C8.87812 19.3713 6.29878 16.7066 6.29878 13.0437C6.29878 9.43759 8.87812 6.74812 12.4842 6.74812C16.1472 6.74812 18.6448 9.43759 18.6448 13.0437C18.6448 16.7066 16.1472 19.3713 12.4842 19.3713Z",
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8346 9.24228L84.0631 3.35883H79.4019V22.7821H83.3419V8.21552L88.8346 15.0121L94.4125 8.1871V22.7821H98.3525V3.35883H93.6628L88.8346 9.24228Z",
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2916 3.36237H26.9515L24.8198 6.71978H27.1256V22.782H31.1474V16.8169H34.3662C38.8037 16.8169 41.7454 13.9746 41.7454 10.0665C41.7454 6.15843 38.8144 3.36237 34.2916 3.36237ZM34.1246 13.4062H31.1296V6.71978H34.1246C36.3736 6.71978 37.7307 8.1409 37.7307 10.0772C37.7307 11.9637 36.3736 13.4062 34.1246 13.4062Z",
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8843 10.3508L64.3665 3.35883H60.3696V22.7821H64.228V8.10538L71.8843 15.3176V22.7821H75.7142V3.35883H71.8843V10.3508Z",
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6125 22.7821H57.1788V19.3678H48.6628V14.6816H55.6796V11.2958H48.6628V6.71623H57.1788V3.35883H44.6125V22.7821Z",
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 6.71623V3.35883H124.43V22.7821H137V19.3678H128.427V14.6816H135.473V11.2958H128.427V6.71623H137Z",
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.779 3.35883H109.753V22.7821H120.017L122.185 19.3678H113.779V3.35883Z",
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.062 3.36237H102.04V22.782H106.062V3.36237Z",
    fill: "#005AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1562_6817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 20.1409,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainLogo);
export default __webpack_public_path__ + "static/media/icon-main-logo.ebe6900ea893a65b6258930c796f0f5d.svg";
export { ForwardRef as ReactComponent };